import estoreDeliveries from "../services/estore.deliveries";
import notification from "../services/notification";
import organization from "../services/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        deliverySchedules: [],
        deliveryScheduleDetails: [],
        branches: [],
        branchOptions: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        editing: false,
        searching: false,
        errors: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        branches(state, branches) {
            state.branches = branches;
            state.loading = false;
        },
        branchOptions(state, branchOptions) {
            state.branchOptions = branchOptions;
            state.loading = false;
        },
        editing(state, value) {
            state.editing = value;
        },
        deliverySchedules(state, deliverySchedules) {
            state.deliverySchedules = deliverySchedules;
            state.loading = false;
            state.searching = false;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        editing(state, value) {
            state.editing = value;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },
        setDetails(state, details) {
            state.deliveryScheduleDetails = details;
        }
    },
    actions: {
        async getBranches({ commit }) {
            commit("loading");
            try {
                let response = await organization.getBranches();
                commit("branches", response);
                commit(
                    "branchOptions",
                    response.map(obj => {
                        var rObj = {};
                        rObj["value"] = obj.uuid;
                        rObj["text"] = obj.name;
                        return rObj;
                    })
                );
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getDeliverySchedules({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreDeliveries.getDeliverySchedules(
                    param
                );

                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                await commit("deliverySchedules", response.list);

                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveDeliverySchedule({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreDeliveries.saveDeliverySchedule(
                    param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot create new schedule.");
                if (
                    errors.errors.hasOwnProperty("branch_uuid") &&
                    errors.errors.branch_uuid ==
                        "The branch uuid has already been taken."
                ) {
                    commit("errors", {
                        errors: {
                            branch_name:
                                "The branch name has already been taken"
                        }
                    });
                } else {
                    commit("errors", errors);
                }
                commit("loading", false);
            }
        },
        async updateDeliverySchedule({ commit }, data) {
            commit("loading");
            try {
                let response = await estoreDeliveries.updateDeliverySchedule(
                    data.uuid,
                    data.param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update schedule.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateVisibilityDeliverySchedule({ commit }, data) {
            commit("loading");
            try {
                let response = await estoreDeliveries.updateVisibilityDeliverySchedule(
                    data.uuid,
                    data.param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update package.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
        async deleteDeliverySchedule({ commit }, uuid) {
            commit("loading");
            try {
                let response = await estoreDeliveries.deleteDeliverySchedule(
                    uuid
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(errors.errors.message);
                commit("loading", false);
            }
        },
        async viewDeliverySchedule({ commit }, uuid) {
            commit("loading");
            try {
                let response = await estoreDeliveries.viewDeliverySchedule(
                    uuid
                );
                let formattedSchedules = {
                    Monday: [],
                    Tuesday: [],
                    Wednesday: [],
                    Thursday: [],
                    Friday: [],
                    Saturday: [],
                    Sunday: []
                };
                let daysVisibility = {
                    Monday: false,
                    Tuesday: false,
                    Wednesday: false,
                    Thursday: false,
                    Friday: false,
                    Saturday: false,
                    Sunday: false
                };
                for (var day in formattedSchedules) {
                    let deliveryTimesLength = response.schedule.delivery_day.find(
                        delivery_day => delivery_day.day_of_week === day
                    ).delivery_time.length;
                    if (deliveryTimesLength > 0) {
                        daysVisibility[day] = true;
                        formattedSchedules[
                            day
                        ] = response.schedule.delivery_day
                            .find(
                                delivery_day => delivery_day.day_of_week === day
                            )
                            .delivery_time.map(obj => {
                                var rObj = {};
                                rObj["start_time"] = obj.start_time;
                                rObj["end_time"] = obj.end_time;
                                rObj["slots"] = obj.slots;
                                return rObj;
                            });
                    } else {
                        daysVisibility[day] = false;
                        formattedSchedules[day].push({
                            start_time: "",
                            end_time: "",
                            slots: 0
                        });
                    }
                }
                response.schedule.schedules = formattedSchedules;
                response.schedule["days_visibility"] = daysVisibility;
                commit("setDetails", response.schedule);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        }
    }
};
